const AUTH_SESSION_FRAGMENTS = [
  '/auth/automy',
  '/auth/portal',
  '/auth/refreshToken',
  '/refreshToken',
  '/auth/logout',
  '/logout',
];

/**
 * Login / mint / refresh / logout. A 401 here is the credential being tried,
 * not a stale Bearer — queueing + refresh loops /auth/automy forever and the
 * portal tab never leaves PageLoading.
 */
export const isAuthSessionUrl = (...candidates) =>
  candidates.some((url) => {
    if (!url || typeof url !== 'string') return false;
    const path = url.split('?')[0];
    if (AUTH_SESSION_FRAGMENTS.some((fragment) => path.includes(fragment))) return true;
    if (/\/auth\/?$/.test(path)) return true;
    return (
      path.includes('/auth/') && !path.includes('authorize') && !path.includes('changePassword')
    );
  });
